


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.secure-alumni-ah-signon.modules/ah-login-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/secure-alumni-ah-signon-ah-login-module-es6" */ "@sparta.secure-alumni-ah-signon.modules/ah-login-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/secure-alumni-ah-signon-ah-login-module-styles" */ "@sparta.secure-alumni-ah-signon.modules/ah-login-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-login-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-login-shared-component-es6" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-login-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-identity-verification-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-identity-verification-shared-component-es6" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-identity-verification-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-stepup-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-stepup-shared-component-es6" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-stepup-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-contact-verification-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-contact-verification-shared-component-es6" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-contact-verification-shared-component/dist/es6.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-credential-creation-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-credential-creation-shared-component-es6" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-credential-creation-shared-component/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/login-client-config.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-client-config.json" */ "file:///apps/wt/deploy/tmp/CF410126/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-client-config-en-T1789575574461.json" )}
    },
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/login-page.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-page.json" */ "file:///apps/wt/deploy/tmp/CF410126/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-page-en-T1789575574461.json" )}
    },
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/error-messages.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-error-messages.json" */ "file:///apps/wt/deploy/tmp/CF410126/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-error-messages-en-T1789575574461.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
